import styled from 'styled-components';
export const Layout = styled.div `
  position: absolute;
  pointer-events: auto;
`;
export const List = styled.div `
  display: inline-flex;
  position: relative;
  top: 6px;
  left: 6px;

  gap: 2px;
  justify-content: center;
  align-items: center;

  border-radius: var(--radius-brand);
  border: 1px solid var(--border-secondary);
  padding: 3px;

  background: var(--bg-primary);

  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);
`;
export const ListItem = styled.button `
  display: flex;

  justify-content: center;
  align-items: center;
  gap: var(--space-250);

  border-radius: var(--radius-brand);
  padding: 0 var(--space-250);

  height: 32px;

  font-size: var(--font-size-300);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);

  &:hover {
    background: var(--bg-transparent);
  }
`;
export const Divider = styled.div `
  display: flex;

  justify-content: center;
  align-items: center;
  gap: 8px;

  padding: 0 2px;

  &:after {
    content: '';
    width: 1px;
    height: 24px;
    background: var(--bg-transparent-strongest);
  }
`;
